module.exports = require('../dist/compat/math/range.js').range;
